import { RootState } from 'store';

export const selectAppointmentStatuses = ({ appointments }: RootState) => appointments.statuses.rows;
